export const usePrintScreen = () => {
  const isPrinting = autoResetRef(false, 1000)

  const onPrintScreen = async () => {
    isPrinting.value = true
    await nextTick()
    window.print()
  }

  const handleBeforePrint = async (_e: Event) => {
    isPrinting.value = true
    await nextTick()
  }

  onMounted(() => {
    window.addEventListener('beforeprint', handleBeforePrint)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('beforeprint', handleBeforePrint)
  })

  return {
    isPrinting,
    onPrintScreen,
  }
}
